var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#171C1E",
  d: "M9.15 2.855a.5.5 0 0 0-.705 0L6 5.295 3.555 2.85a.498.498 0 0 0-.705.705L5.295 6 2.85 8.445a.498.498 0 0 0 .705.705L6 6.705 8.445 9.15a.498.498 0 0 0 .705-.705L6.705 6 9.15 3.555c.19-.19.19-.51 0-.7"
})));
export { SvgClose as ReactComponent };